import { HALManager } from "core";

import { SkillsFacetsCategories } from "shared/modules/Skills/models/SkillsFacetsCategories";
import { HttpOperationError } from "shared/utils/exceptions";
import { parseToUrlQuery } from "shared/utils/http";

import { FacetCategories, FacetCategory } from "models";

import { HttpClient } from "./HttpClient";
import { getApiUrl } from "./UrlBuilder";

export class FacetsService {
  private httpClient: HttpClient = new HttpClient();

  public async getFacetCategories(
    language: string,
    defaultLanguage?: string
  ): Promise<FacetCategory[]> {
    const categories: string[] = [
      ...this.getSkillFacetCategoryNames(),
      ...this.getBasicInfoFacetCategoryNames(),
    ];

    const urlRequest = getApiUrl(
      HALManager.getFacetCategoriesUrl(),
      parseToUrlQuery({ lang: language.toLowerCase(), categories })
    );

    try {
      const response = await this.httpClient.get<FacetCategory[]>(urlRequest);
      return response.object;
    } catch (error) {
      if (defaultLanguage) {
        return await this.getFacetCategories(defaultLanguage);
      } else {
        throw new HttpOperationError(
          urlRequest,
          "Getting facets has been failed",
          error
        );
      }
    }
  }

  public getBasicInfoFacetCategoryNames() {
    return Object.keys(FacetCategories).map((key) => FacetCategories[key]);
  }

  public getSkillFacetCategoryNames() {
    return Object.keys(SkillsFacetsCategories).map(
      (key) => SkillsFacetsCategories[key]
    );
  }
}

export default new FacetsService();
